import { store } from '@betacrew/jars-flux';
import { all, call, put, takeLeading } from 'redux-saga/effects';
import General from '../../../../libs/utility/General';
import FormsDataService from '../../../../services/FormsDataService';

import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { PAGE_STATE } from '../../constants/constants';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { CURRENT_FORM_CREATION_MODULE } from '../constants';

import { componentKey, setExcelFields, setFormFields, setFormsList, setLoadingState, updateBatchImportFormData, setIsStateFilingApplicable, setFormSettings, setUploadFileLoadingState} from './BatchImportSlice';
import { BATCH_FORMS_LOADING_STATES } from './constants';

export const { getFormsList, checkUseSavedOrStartNewImport, continueWithSavedData, uploadFile, submitFileOrPastedData, getFieldsForMatching, submitBatchImportMatchedFields, downloadBatchImportTemplate, checkStateFilingApplicable, getFormSetting } = {
    getFormsList: (payload) => {
        return {
            type: "BATCH_IMPORT/GET_FORMS_LIST",
            payload: payload
        }
    },
    checkUseSavedOrStartNewImport: (payload) => {
        return {
            type: "BATCH_IMPORT/CHECK_SAVED_DATA",
            payload
        }
    },
    continueWithSavedData: (payload) => {
        return {
            type: "BATCH_IMPORT/USE_SAVED_DATA",
            payload: payload
        }
    },
    uploadFile: (payload) => {
        return {
            type: "BATCH_IMPORT/UPLOAD_FILE",
            payload: payload
        }
    },
    submitFileOrPastedData: (payload) => {
        return {
            type: "BATCH_IMPORT/SUBMIT_FILE_PASTED_DATA",
            payload: payload
        }
    },
    getFieldsForMatching: (payload) => {
        return {
            type: "BATCH_IMPORT/GET_FIELDS_MATCHING",
            payload: payload
        }
    },
    submitBatchImportMatchedFields: (payload) => {
        return {
            type: "BATCH_IMPORT/SUBMIT_MATCHED_FIELDS",
            payload: payload
        }
    },
    downloadBatchImportTemplate: (payload) => {
        return {
            type: "BATCH_IMPORT/DOWNLOAD_TEMPLATE",
            payload: payload
        }
    },
    checkStateFilingApplicable: (payload) => {
        return {
            type: "BATCH_IMPORT/CHECK_STATEFILING_APPLICABLE",
            payload: payload
        }
    },
    getFormSetting: (payload) => {
        return {
            type: "BATCH_IMPORT/GET_FORM_SETTING",
            payload: payload
        }
    },
}

function* getFormsListAsync(action) {
    try {
        yield put(setLoadingState({ state: BATCH_FORMS_LOADING_STATES.SELECT_YEAR_LOADING }));
        const response = yield FormsDataService.getFormsList();
        if(response?.data){
            if(response.data.Status === 0){
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            }else if(response.data.Status === 1){
                const formsList = response.data.Data;
                yield put(setFormsList({
                    ...formsList,
                    Forms: formsList.Forms.filter(record => record.AvailableFor.split(',').includes(CURRENT_FORM_CREATION_MODULE.BATCH)),
                }));

                if(formsList?.Years){
                    const latestYear = Math.max(...formsList?.Years)
                    if(latestYear){
                        yield put(updateBatchImportFormData({selectedYear: latestYear}));
                    }
                }
            }
        }
    } catch(error) {
        console.log(error)
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    }finally {
        yield put(setLoadingState({ state: BATCH_FORMS_LOADING_STATES.SELECT_YEAR_READY }))
    }
}

function* downloadBatchImportTemplateAsync(action) {
    try {
        yield put(setLoadingState({ state: BATCH_FORMS_LOADING_STATES.UPLOAD_FILE_PAGE_LOADING }));
        const { formId, year, fileType, quarter } = action.payload;
        const response = yield FormsDataService.downloadBatchImportTemplate(formId, year, fileType, quarter);
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }));

        if(response?.data){
            if (response?.data.Status) {
                const { Base64, Name } = response?.data?.Data;
                General.downloadFile(Base64, Name);
            } else {
                yield put(addNotifications({ heading: "Something went wrong", message: response?.data?.Message }));
            }
        }
    } catch(error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    }finally {
        yield put(setLoadingState({ state: BATCH_FORMS_LOADING_STATES.UPLOAD_FILE_PAGE_READY }))
    }
}

function* checkUseSavedOrStartNewImportAsync(action) {

    try {
        yield put(setLoadingState({ state: BATCH_FORMS_LOADING_STATES.UPLOAD_FILE_PAGE_LOADING }))
        const {formId, modifiedFile, year} = action.payload;
        if(formId){
            const response = yield FormsDataService.checkUseSavedOrStartNewImport(formId, year);
            yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }));
            if(response?.data){
                if(response?.data?.Status === 0){
                    if(modifiedFile !== null){
                        yield call(uploadFileAsync, { payload: {formId: formId, modifiedFile: modifiedFile, year: year}});
                    }else{
                        yield put(addNotifications({ heading: "Saved data result", message: response?.data?.Message, variant: TOASTER_VARIANT.WARNING }));
                    }
                }else if(response?.data?.Status === 1) {
                    yield put(updateBatchImportFormData({isPreviousSavedData: true}));
                }
            }
        }
    } catch (error) {
        yield put(addNotifications({ heading: "Facing some error", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: BATCH_FORMS_LOADING_STATES.UPLOAD_FILE_PAGE_READY }))
    }

}

function* continueWithSavedDataAsync(action){
    try {
        yield put(updateBatchImportFormData({isPreviousSavedData: null}));
        const {formId, year} = action.payload;
        if(formId){
            yield put(setLoadingState({ state: BATCH_FORMS_LOADING_STATES.UPLOAD_FILE_PAGE_LOADING, message: "Continuing using the saved data..." }))
            const response = yield FormsDataService.continueWithSavedData(formId, year);
            if(response?.data){
                if(response?.data?.Status === 0){
                    yield put(addNotifications({ heading: "Error", message: response?.data?.Message }));
                }else if(response?.data?.Status === 1) {
                    yield put(updateBatchImportFormData({goToListingStep: true}));
                }
            }
        }
    } catch (error) {
        yield put(addNotifications({ heading: "Facing some error", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: BATCH_FORMS_LOADING_STATES.UPLOAD_FILE_PAGE_READY }))
    }
}

function* uploadFileAsync(action){
    try {
        yield put(updateBatchImportFormData({isPreviousSavedData: null}));
        yield put(setLoadingState({ state: BATCH_FORMS_LOADING_STATES.UPLOAD_FILE_PAGE_LOADING }))
        const {formId, modifiedFile, year} = action.payload;
        const formData = new FormData();
        formData.append("files", modifiedFile);
        if(formId){
            const response = yield FormsDataService.uploadFile(formId, formData, year);
            if(response?.data){
                if(response?.data?.Status === 0){
                    yield put(addNotifications({ heading: "Error in uploading file", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
                }else if(response?.data?.Status === 1) {
                    yield put(addNotifications({ heading: "File Uploaded Successfully", message: "File Uploaded Successfully. You can proceed to the next step.", variant: TOASTER_VARIANT.SUCCESS }));
                    yield put(updateBatchImportFormData({useUploadedFile: true}));
                }
            }
        }
    } catch (error) {
        yield put(addNotifications({ heading: "Facing some error", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setLoadingState({ state: BATCH_FORMS_LOADING_STATES.UPLOAD_FILE_PAGE_READY }))
    }
}

function* submitFileOrPastedDataAsync(action){
    const {formId, data, year, actionLoadingState} = action.payload;
    try {
        yield put(updateBatchImportFormData({useUploadedFile: false}));
        yield put(setLoadingState({ state: actionLoadingState?.loading }));
        const response = yield FormsDataService.submitFileOrPastedData(formId, data, year);
        if(response?.data){
            if(response?.data?.Status === 0){
                yield put(addNotifications({ heading: "Error", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
            }else if(response?.data?.Status === 1) {
                yield put(updateBatchImportFormData({isUploadedDataSessionSet: true}));
            }
        }
    } catch (error) {
        yield put(addNotifications({ heading: "Facing some error", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setLoadingState({ state: actionLoadingState?.ready }))
    }
}

function* getFieldsForMatchingAsync(action){
    try {
        const {formId, year} = action.payload;
        yield put(updateBatchImportFormData({useUploadedFile: false}));
        yield put(setLoadingState({ state: BATCH_FORMS_LOADING_STATES.MATCHING_PAGE_LOADING }));
        const response = yield FormsDataService.getFieldsForMatching(formId, year);
        if(response?.data){
            if(response?.data?.Status === 0){
                yield put(addNotifications({ heading: "Error in fetching fields", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
            }else if(response?.data?.Status === 1) {
                
                const formFields = Object.entries(response?.data?.Data?.FixedColumns ?? {}).map(([name, label]) => ({ name, id: name, label }));
                const excelFields = Object.entries(response?.data?.Data?.ExcelColumns ?? {}).map(([id, label]) => ({ id, label }));
                const excelFieldsWithMatch = excelFields.map((excelField) => {
                    const match = formFields.find((formField) => formField.label === excelField.label);
                    if (match) {
                        return {
                            ...excelField,
                            matchedFormField: { ...match },
                        };
                    } else {
                        return excelField;
                    }
                });
    
                const formFieldsWithMapping = formFields.map((formField) => {
                    const match = excelFields.find((excelField) => excelField.label === formField.label);
                    if (match) {
                        return {
                            ...formField,
                            mapped: true,
                        };
                    } else {
                        return formField;
                    }
                });
                    
                yield put(setFormFields(formFieldsWithMapping));
                yield put(setExcelFields(excelFieldsWithMatch));
            }
        }
    } catch (error) {
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setLoadingState({ state: BATCH_FORMS_LOADING_STATES.MATCHING_PAGE_READY }))
    }
}

function* submitBatchImportMatchedFieldsAsync(action){
    
    const { formId, matchedFieldsData, year, quarter, pageLoadingState } = action.payload;
    try {
        yield put(setLoadingState({ state: pageLoadingState?.loading }));
        const response = yield FormsDataService.submitMatchedFields(formId, matchedFieldsData, year, quarter);
        if(response?.data?.Status === 0){
            yield put(addNotifications({ heading: "Error in submitting data", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
        }else if(response?.data?.Status === 1) {
            yield put(updateBatchImportFormData(({goToListingStep: true})));
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Facing some error", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setLoadingState({ state: pageLoadingState.ready }))
    }
}

function* checkStateFilingApplicableAsync(action){
    try {
        const { formId } = action.payload;
        yield put(setLoadingState({ state: BATCH_FORMS_LOADING_STATES.GRID_PAGE_LOADING}));
        const response = yield FormsDataService.checkStateFilingApplicable(formId);
        if(response?.data){
            if(response?.data?.Status === 0){
                yield put(setIsStateFilingApplicable(false));
            }else if(response?.data?.Status === 1) {
                yield put(setIsStateFilingApplicable(true));
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setLoadingState({ state: BATCH_FORMS_LOADING_STATES.GRID_PAGE_READY }))
    }
}

function* getFormSettingAsync(action){
    try {
        const { formId, year } = action.payload;
        yield put(setUploadFileLoadingState({ state: BATCH_FORMS_LOADING_STATES.GET_FORM_SETTINGS_LOADING }));
        const response = yield FormsDataService.getFormSetting(formId, year);
        if(response?.data){
            if(response?.data?.Status === 1) {
                yield put(setFormSettings(response?.data?.Data));
            }else{
                yield put(addNotifications({ heading: "Error", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setUploadFileLoadingState({ state: BATCH_FORMS_LOADING_STATES.GET_FORM_SETTINGS_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLeading(getFormsList().type, getFormsListAsync),
        takeLeading(downloadBatchImportTemplate().type, downloadBatchImportTemplateAsync),
        takeLeading(checkUseSavedOrStartNewImport().type, checkUseSavedOrStartNewImportAsync),
        takeLeading(continueWithSavedData().type, continueWithSavedDataAsync),
        takeLeading(uploadFile().type, uploadFileAsync),
        takeLeading(submitFileOrPastedData().type, submitFileOrPastedDataAsync),
        takeLeading(getFieldsForMatching().type, getFieldsForMatchingAsync),
        takeLeading(submitBatchImportMatchedFields().type, submitBatchImportMatchedFieldsAsync),
        takeLeading(checkStateFilingApplicable().type, checkStateFilingApplicableAsync),
        takeLeading(getFormSetting().type, getFormSettingAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);